<template>
    <div class="message-container d-flex justify-content-begin mb-2 inbound">
        <div class="message">
            <div class="header font-weight-bold">
                <span class="contact-filemaker-id" v-if="contactFilemakerId">{{ contactFilemakerId }}</span>
                <span class="contact-full-name">{{ contactFullName | uppercase }}</span>
            </div>
            <div class="content d-flex flex-column" :style="styles">
                <div class="content-body w-100 d-flex">
                  <span class="message-content w-100">{{ content }}</span>
                  <message-settings :settings="settings" :message="message"></message-settings>
                </div>
                <media-list :media="media" v-if="hasMedia" :is-inbound="true"></media-list>
            </div>
            <div class="footer text-black-50">
                {{ statusString | uppercase }}
            </div>
        </div>
        <div class="d-flex align-items-center">
          <el-tooltip effect="light" placement="right" content="Message is preserved" v-if="isPreserved">
            <i class="fas fa-bookmark ml-1"></i>
          </el-tooltip>
        </div>
    </div>
</template>

<script>
  import ChatTextMessage from "./chat-text-message";
  import MediaList from "../media-list";
  import MessageSettings from "../message-settings";

  export default {
    extends: ChatTextMessage,

    components: {
      MediaList,
      MessageSettings,
    },

    computed: {
      /**
       * @return {String|null}
       */
      contactFullName() {
        return _.get(this.contact, 'full_name', null);
      },

      /**
       * @return {String|null}
       */
      contactFilemakerId() {
        return _.get(this.contact, 'filemaker_id', null);
      },

      /**
       * @return {Object|null}
       */
      messageCreatedAt() {
        return _.get(this.message, 'created_at', null);
      },

      /**
       * @return {String}
       */
      statusString() {
        return 'MESSAGE RECEIVED: ' + (this.formatTime(this.messageCreatedAt) || '');
      },

      /**
       * @return {boolean}
       */
      hasMedia() {
        return !_.isEmpty(_.get(this.message, 'media', []));
      },

      /**
       * @return {Object|null}
       */
      media() {
        return _.get(this.message, 'media', null);
      },

      /**
       * @return {Object}
       */
      styles() {
        if (_.isEmpty(this.brand)) {
            return {};
        }

        const {
          'other.item.text.color': color,
          'other.item.background.color': backgroundColor
        } = {...this.brand.styles};

        // remove empty values
        return _.pickBy({color, backgroundColor}, _.identity);
      },

      /**
       * @returns {boolean}
       */
      isPreserved() {
        return Boolean(_.get(this.message, 'is_preserved'));
      },
    },
  }
</script>
